import { generatePath } from 'react-router'
import { routes } from '~/queries/routes'
import { FlexContainer, FlexItem } from '~/components/Grid'

import { Link } from '@remix-run/react'
import classNames from 'classnames'
import { ResponsiveImage } from '~/components/ResponsiveImage'
import { TypeArticle, TypeCategorySortingSkeleton } from '~/types/contentful'
import { Asset, Entry } from 'contentful'

export type ArticleBigPreviewProps = {
  data: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const ArticleBigPreview = ({ data }: ArticleBigPreviewProps) => {
  const { slug, title, category, color, illustration, illustrationAlt, gated } = data.fields

  const illustrationImg = illustration as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
  const categoryAsset = category as unknown as Entry<
    TypeCategorySortingSkeleton,
    'WITHOUT_UNRESOLVABLE_LINKS',
    string
  >

  return (
    <div
      className={classNames(
        'bg-neutral-5 text-neutral-100 max-xl:first:p-[calc(20px_+_var(--header-height))_0_60px] max-md:first:p-[calc(32px_+_var(--header-height))_0_72px] p-[var(--header-height)_0_120px] max-xl:pt-24 max-xl:px-0 max-xl:pb-25 max-md:pt-16 max-md:pb-20',
      )}
      style={{ backgroundColor: color }}
    >
      <FlexContainer justify="end">
        <FlexItem
          className="relative flex xl:flex-col max-xl:flex-row max-md:flex-col max-xl:items-center max-xl:py-0 max-md:px-2 max-lg:px-8 max-xl:max-w-[1000px]"
          desktop={10}
          laptop={12}
        >
          {gated && (
            <div className="absolute top-4 right-4 py-1 px-3 bg-white text-neutral-100 rounded-2xl text-s max-xl:hidden max-xl:px-2">
              Premium
            </div>
          )}
          {illustrationImg && (
            <div className="block min-h-80 lg:min-h-[520px] mb-1 w-[60%] ml-[10%] max-xl:order-2 max-xl:w-1/2 max-xl:ml-[11%] max-xl:mb-0 max-md:order-1 max-md:ml-0 max-md:mb-8 max-md:w-[71%]">
              <ResponsiveImage
                asset={illustrationImg.fields}
                alt={illustrationAlt}
                opts={{ width: 544 }}
              />
            </div>
          )}
          <div className="max-xl:order-1 max-xl:w-[38%] max-md:order-2 max-md:w-full max-md:py-0 max-md:px-4 max-md:text-center">
            {categoryAsset && (
              <div className="text-s max-md:mb-2 mb-5">{categoryAsset.fields.name}</div>
            )}
            <Link
              className="block pr-13 max-xl:pr-0 max-w-[680px] before:content-none before:absolute before:top-0 before:left-0 before:right-0 before:bottom-0 text-xl"
              to={generatePath(routes.article, { slug })}
            >
              {title}
            </Link>
          </div>
        </FlexItem>
      </FlexContainer>
    </div>
  )
}
